import { render, staticRenderFns } from "./chatDrawer.vue?vue&type=template&id=1c743c22&scoped=true&"
import script from "./chatDrawer.vue?vue&type=script&lang=js&"
export * from "./chatDrawer.vue?vue&type=script&lang=js&"
import style0 from "./chatDrawer.vue?vue&type=style&index=0&id=1c743c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c743c22",
  null
  
)

export default component.exports